<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="
            $t.__(
                'activities.listing.massActions.ActivitiesListingMassReschedule.reschedule_activities_title',
            )
        "
        :primaryAction="{
            label: $t.__('common.actions.confirm'),
            action: () => confirmMassReschedule(),
            loading: isSubmitting,
            disabled: isDateInvalid,
        }"
        :secondaryActions="[
            { label: $t.__('common.actions.cancel'), action: () => $emit('close') },
        ]"
        @closed="$emit('close')"
    >
        <template #default>
            <span class="typographies-paragraph-medium-regular mass-reschedule-text">
                {{ textContent }}
            </span>
            <CompassCalendar
                v-model="selectedDate"
                :disableWeekDays="disabledWeekDays"
                :lang="uiLang"
            />
        </template>
    </CompassDialog>
</template>
<script>
import { massReschedule } from 'api/activities/activitiesMassActionsService.js';
import { difference } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        workingDays: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            selectedDate: '',
            isSubmitting: false,
        };
    },
    computed: {
        ...mapStateUser(['uiLang']),
        disabledWeekDays() {
            return difference([0, 1, 2, 3, 4, 5, 6], this.workingDays);
        },
        textContent() {
            return this.$l10n.n__(
                'Vous vous apprêtez à reprogrammer une activité.',
                'Vous vous apprêtez à reprogrammer %d activités.',
                this.selectedActivities.length,
                this.selectedActivities.length,
            );
        },
        isDateInvalid() {
            return (
                this.selectedDate === '' ||
                this.disabledWeekDays.includes(moment(this.selectedDate).day())
            );
        },
    },
    created() {
        this.selectedDate = moment().format('YYYY-MM-DD');
    },
    methods: {
        async confirmMassReschedule() {
            try {
                this.isSubmitting = true;
                await massReschedule(this.selectedActivities, this.selectedDate);
                await new Promise(() =>
                    setTimeout(() => {
                        this.$emit('close');
                        this.onSuccess();
                    }, 200),
                );
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.mass-reschedule-text {
    display: block;
    margin-bottom: var(--spacing-2);
}
</style>
